// import React from "react";
// import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
// import { Icon } from "../Component";

// const ExportButton = ({ title, options, className, onChange }) => {
//   return (
//     <UncontrolledDropdown direction="down" className={`me-1 ${className}`}>
//       <DropdownToggle outline color="light" className="btn-action bg-white d-none d-sm-inline-flex  fw-normal">
//         <span>
//           <Icon className={""} name="download"></Icon>
//         </span>
//       </DropdownToggle>
//       <DropdownMenu>
//         <ul className="link-list-opt">
//           {options?.length > 0 &&
//             options?.map((oItem, oIndex) => (
//               <li key={"option" + oIndex}>
//                 <DropdownItem
//                   tag="a"
//                   href="#links"
//                   onClick={(ev) => {
//                     ev.preventDefault();
//                     onChange(oItem?.value);
//                   }}
//                 >
//                   <span>{oItem?.label}</span>
//                 </DropdownItem>
//               </li>
//             ))}
//         </ul>
//       </DropdownMenu>
//     </UncontrolledDropdown>
//   );
// };

import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Icon } from "../Component";

const ExportButton = ({ className, onChange, title, options = [], hideOption = false, isSwitchOn }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showExportOptions, setShowExportOptions] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const toggleExportOptions = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowExportOptions((prev) => !prev);
  };

  const handleOptionClick = (type) => (e) => {
    e.preventDefault();
    onChange(type);
    setDropdownOpen(false);
    setShowExportOptions(false);
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} direction="down" className={`me-1 ${className}`}>
      <DropdownToggle outline color="light" className="btn-action bg-white d-inline-flex fw-normal">
        <span className="d-flex align-items-center">
          <Icon name="download" className={title && `me-1`} />
          {title}
        </span>
      </DropdownToggle>

      <DropdownMenu>
        <div
          onClick={toggleExportOptions}
          className="dropdown-item d-flex align-items-center justify-content-between"
          style={{ cursor: "pointer" }}
        >
          <span>
            <Icon name="arrow-up" className="me-1 fs-6" />
            Export
          </span>
          <Icon name={showExportOptions ? "chevron-up" : "chevron-down"} className="fs-6" />
        </div>

        {showExportOptions &&
          options.map((option) => (
            <DropdownItem key={option?.value} onClick={handleOptionClick(option?.value)}>
              <Icon
                name={
                  option?.value.toLowerCase() === "pdf"
                    ? "file-pdf"
                    : option?.value.toLowerCase().includes("xls")
                    ? "file-xls"
                    : "file"
                }
                className="me-1 fs-6"
              />
              {option?.label}
            </DropdownItem>
          ))}
        {!hideOption && !isSwitchOn && (
          <DropdownItem onClick={handleOptionClick("ALL")}>
            <Icon name="download" className="me-1 fs-6" />
            Download All
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default ExportButton;
